import Box from '@material-ui/core/Box'
import { useStoryblokEditable } from '@sb-konzept/gatsby-source-storyblok'
import Image from 'gatsby-image'
import React from 'react'

function NewsImage(props) {
  const { content, rowAspectRatioSum, onClick } = props
  const { image, imageAltText } = content
  const { editableProps } = useStoryblokEditable()
  const aspectRatio = 1

  return !image.localFile ? null : (
    <Box
      css={{
        display: 'inline-block',
        width: `${(aspectRatio / rowAspectRatioSum) * 100}%`,
        cursor: 'pointer'
        // margin: 4
      }}
      onClick={onClick}
    >
      <Image
        alt={imageAltText || 'image'}
        fluid={{
          ...image.localFile?.childImageSharp.fluid,
          aspectRatio
        }}
      />
    </Box>
  )
}

export default NewsImage
